(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesCodeController', LicencesCodeController);

    LicencesCodeController.$inject = ['$state', '$uibModal', 'LicenceType', 'Vendor', 'LicenceCode', 'AlertService', 'pagingParams'];

    function LicencesCodeController($state, $uibModal, LicenceType, Vendor, LicenceCode, AlertService, pagingParams) {
        var vm = this;
        vm.licences = [];
        vm.checkTypes = [];
        vm.vendor = [];
        vm.viewLicence = [];
        vm.viewActiveLicence = [];

        var clearTable = {};
        localStorage.setItem("licence-code-detail", JSON.stringify(clearTable));

        vm.loadLicence = function(){
            var body = {
                page: 0,
                size: 20
            };

            LicenceCode.query(body, onLicenceSuccess, onLicenceError);

            function onLicenceSuccess(data) {
                vm.viewLicence = data;
            }

            function onLicenceError() {}
        };

        vm.loadActiveLicence = function(){
            var body = {
                id: -1,
                page: 0,
                size: 20,
            };

            LicenceCode.activeLicence(body, onLicenceSuccess, onLicenceError);

            function onLicenceSuccess(data) {
                vm.viewActiveLicence = data;
            }

            function onLicenceError() {}
        };

        vm.loadTypes = function () {
            LicenceType.query(onTypeSuccess, onTypeError);

            function onTypeSuccess(data) {
                vm.checkTypes = data;
            }

            function onTypeError() {}
        };

        vm.loadVendor = function () {
            Vendor.query(onVendorSuccess, onVendorError);

            function onVendorSuccess(data) {
                vm.vendor = data;
            }

            function onVendorError() {}
        };

        vm.newVendor = function () {
            $uibModal.open({
                templateUrl: 'app/admin/licences/new-vendor.html',
                controller: 'NewVendorController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.go('licences-code', null, {reload: true});
            });
        };

        vm.save = function () {
            vm.isSaving = true;

            var body = {
                licenceType: vm.licences.checkType,
                vendor: vm.licences.vendor,
                duration: vm.licences.duration,
                quantity: vm.licences.quantity
            };

            LicenceCode.save(body, onSuccess, onError);

            function onSuccess() {
                vm.isSaving = false;
                $state.reload();
            }

            function onError(){
                vm.isSaving = false;
            }
        };

        vm.clear = function () {
            $state.reload();
        };

        vm.loadTypes();
        vm.loadVendor();
        vm.loadLicence();
        vm.loadActiveLicence();

    }
})();
